import React from 'react'
import { Link, Route } from 'react-router-dom'

import { clientLogo } from 'utils/theme'

import Container from './styles'


const DefaultLayout = ({ component: Component, ...rest }) => {

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <Container>
          <div className='full_width'>
            <header
              className="header"
            >
              <span>
                <Link to="/">
                  <img src={clientLogo} alt="Logo" className="header__logo" />
                </Link>
              </span>
            </header>
            <div className="content">
              <main className="main">
                <Component {...matchProps} />
              </main>
            </div>
          </div>
        </Container>
      )}
    />
  )
}

export default DefaultLayout
